// Extracted verbatim (programmatically, not hand-transcribed) from
// SCERS_Retirement_Calculator_v6_0_7.html on 2026-09-22.
// Do not hand-edit these values. If the source calculator is revised, re-run the
// extraction script against the new version and regenerate this file.

export const tierConfig = {
  "M1": {
    "name": "Miscellaneous Tier 1",
    "minAge": 50,
    "erf": "ERF 2004 31676.14",
    "mort": "misc",
    "formula": "miscIntegrated"
  },
  "M1O": {
    "name": "Miscellaneous Tier 1 Old Formula",
    "minAge": 50,
    "erf": "ERF 2012 31676.1",
    "mort": "misc",
    "formula": "miscOld",
    "oldFormula": true
  },
  "M2": {
    "name": "Miscellaneous Tier 2",
    "minAge": 50,
    "erf": "ERF 2004 31676.14",
    "mort": "misc",
    "formula": "miscIntegrated"
  },
  "M2O": {
    "name": "Miscellaneous Tier 2 Old Formula",
    "minAge": 50,
    "erf": "ERF 2012 31676.1",
    "mort": "misc",
    "formula": "miscOld",
    "oldFormula": true
  },
  "M3": {
    "name": "Miscellaneous Tier 3",
    "minAge": 50,
    "erf": "ERF 2004 31676.14",
    "mort": "misc",
    "formula": "miscIntegrated"
  },
  "M3O": {
    "name": "Miscellaneous Tier 3 Old Formula",
    "minAge": 50,
    "erf": "ERF 2012 31676.1",
    "mort": "misc",
    "formula": "miscOld",
    "oldFormula": true
  },
  "M4": {
    "name": "Miscellaneous Tier 4",
    "minAge": 50,
    "erf": "ERF 2012 31676.1",
    "mort": "misc",
    "formula": "miscIntegrated"
  },
  "M5": {
    "name": "Miscellaneous Tier 5 (PEPRA)",
    "minAge": 52,
    "erf": "ERF 2013 PEPRA-MISC 5",
    "mort": "misc",
    "formula": "pepraNonIntegrated"
  },
  "S1": {
    "name": "Safety Tier 1",
    "minAge": 41,
    "erf": "ERF 2004 31664.1",
    "mort": "safety",
    "formula": "safetyIntegrated"
  },
  "S1O": {
    "name": "Safety Tier 1 Old Formula",
    "minAge": 41,
    "erf": "ERF OLD 31664",
    "mort": "safety",
    "formula": "safetyOld",
    "oldFormula": true
  },
  "S2": {
    "name": "Safety Tier 2",
    "minAge": 41,
    "erf": "ERF 2004 31664.1",
    "mort": "safety",
    "formula": "safetyIntegrated"
  },
  "S2O": {
    "name": "Safety Tier 2 Old Formula",
    "minAge": 41,
    "erf": "ERF OLD 31664",
    "mort": "safety",
    "formula": "safetyOld",
    "oldFormula": true
  },
  "S3": {
    "name": "Safety Tier 3",
    "minAge": 41,
    "erf": "ERF 2012 31664.2",
    "mort": "safety",
    "formula": "safetyIntegrated"
  },
  "S4": {
    "name": "Safety Tier 4 (PEPRA)",
    "minAge": 50,
    "erf": "ERF 2013 PEPRA-SAF4",
    "mort": "safety",
    "formula": "safetyIntegrated"
  }
} as const;

export const MEMBERSHIP_TIER_OPTIONS = [
  [
    "M1",
    "Miscellaneous Tier 1"
  ],
  [
    "M2",
    "Miscellaneous Tier 2"
  ],
  [
    "M3",
    "Miscellaneous Tier 3"
  ],
  [
    "M4",
    "Miscellaneous Tier 4"
  ],
  [
    "M5",
    "Miscellaneous Tier 5 (PEPRA)"
  ],
  [
    "S1",
    "Safety Tier 1"
  ],
  [
    "S2",
    "Safety Tier 2"
  ],
  [
    "S3",
    "Safety Tier 3"
  ],
  [
    "S4",
    "Safety Tier 4 (PEPRA)"
  ]
] as const;
